import { FormControl } from "@angular/forms";


export class SurveyCustomValidators{

  public static noWhitespaceValidator(control: FormControl) {
    return (control.value || '').trim().length? null : { 'whitespace': true };
  }
}
